import {Injectable} from '@angular/core';

import {BehaviorSubject, Subject} from 'rxjs';
import {KeycloakService} from "./keycloak.service";

@Injectable()
export class UserVerificationService {

  isAdmin: boolean = false;
  adminAttr = KeycloakService.auth.authz.tokenParsed.isAdmin
  message: BehaviorSubject<boolean> = new BehaviorSubject<boolean>(true);
  roamingPartner: Subject<any> = new Subject<any>();

  constructor() {
    // the following check on the "isAdmin" attribute is mandatory because it is a part of the Keycloak response
    // and it is not the result of the back-end's serialization of the UserRepresentation object.
    if (this.adminAttr !== undefined) {
      this.isAdmin = (this.adminAttr.toLowerCase() == 'true');
    }
  }

}
